'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = pixelToNumber;
function pixelToNumber() {
    var pixels = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    return typeof pixels === 'number' ? pixels : Number(String(pixels).replace(/[^\d]/g, '')) || 0;
}